import React from 'react';
import PropTypes from 'prop-types';

/**
 * Help - A wrapper that renders a paragraph with Bulma help class names
 * 
 * This component accepts the same props as Bloomer Help for easy migration
 */
const Help = ({
  className,
  children,
  style,
  hasTextColor,
  isSize,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['help'];
    
    // Add appropriate classes based on props
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    if (hasTextColor) {
      classes.push(`has-text-${hasTextColor}`);
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <p 
      className={getClassNames()} 
      style={style} 
      {...props}
    >
      {children}
    </p>
  );
};

Help.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  hasTextColor: PropTypes.string,
  isSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};

Help.defaultProps = {
  className: '',
  style: {},
  children: null,
  hasTextColor: null,
  isSize: null
};

export default Help;
